/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Document_MovedInputs */

const cs_enum_document_moved = /** @type {(inputs: Enum_Document_MovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument přesunut`)
};

const en_enum_document_moved = /** @type {(inputs: Enum_Document_MovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document moved`)
};

/**
* | output |
* | --- |
* | "Document moved" |
*
* @param {Enum_Document_MovedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_document_moved = /** @type {((inputs?: Enum_Document_MovedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Document_MovedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_document_moved(inputs)
	return cs_enum_document_moved(inputs)
});